module.exports = __webpack_public_path__ + "static/img/zhutu压路机（SCW碰撞预警系统专属）.f9e88e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/zhutu压路机（SCW碰撞预警系统专属）.png
// module id = dh+h
// module chunks = 0